export enum GlobalEnableStatus {
    'disabled' = -1,
    'pending' = 0,
    'enabled' = 1,
    'partial-enabled' = 2,
}
